import notificationTypes from './notificationTypes';
import notificationLevels from './notificationLevels';

const getLevel = function(type) {
    switch(type)
    {
        case notificationTypes.update:
        case notificationTypes.licence:
            return notificationLevels.top;
        case notificationTypes.appError:
            return notificationLevels.page;
        case notificationTypes.operationError:
            return notificationLevels.page;
        default:
            throw 'Cannot find notification level for type ' + type;
    }
};

function Notification(title, message, type, severity, timestamp, actions, dismissable = true)
{
    this.title = title;
    this.message = message;
    this.type = type;
    this.severity = severity;
    this.timestamp = timestamp;
    this.level = getLevel(type);
    this.actions = actions || [];
    this.dismissable = dismissable;
};

export default Notification;


// WEBPACK FOOTER //
// ./src/js/notification/index.js